/*
  Lightweight tab switcher for the Contact Us page's two department forms
  (Orders / Customer Services). Each panel is a fully independent, real
  {% form 'contact' %} - this script only controls which one is visible; it
  never intercepts submission, so native validation, reCAPTCHA and Shopify's
  own error/success handling are untouched.

  After a submission, Shopify reloads the page and repopulates both forms'
  Liquid `form` objects in parallel (it has no way to know which of two
  same-type forms was actually submitted), so on load this checks which
  panel actually has a success message or a validation error and switches to
  that tab automatically, rather than always defaulting to Orders.
*/
(function () {
  "use strict";

  function initTabs(container) {
    if (container.dataset.contactTabsInitialised === "true") return;
    container.dataset.contactTabsInitialised = "true";

    var tabs = Array.prototype.slice.call(container.querySelectorAll(".tt-contact-tabs__tab"));
    if (!tabs.length) return;

    function panelFor(tab) {
      return document.getElementById(tab.getAttribute("aria-controls"));
    }

    function activate(tab) {
      tabs.forEach(function (t) {
        var isActive = t === tab;
        t.classList.toggle("is-active", isActive);
        t.setAttribute("aria-selected", isActive ? "true" : "false");
        t.setAttribute("tabindex", isActive ? "0" : "-1");
        var panel = panelFor(t);
        if (panel) panel.hidden = !isActive;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () {
        activate(tab);
      });

      tab.addEventListener("keydown", function (e) {
        var targetIndex = null;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") targetIndex = (index + 1) % tabs.length;
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") targetIndex = (index - 1 + tabs.length) % tabs.length;
        if (targetIndex === null) return;
        e.preventDefault();
        tabs[targetIndex].focus();
        activate(tabs[targetIndex]);
      });
    });

    // Default to the first tab, unless a different panel already shows
    // feedback from a just-completed submission.
    var initialTab = tabs[0];
    tabs.some(function (tab) {
      var panel = panelFor(tab);
      if (!panel) return false;
      var hasFeedback = panel.querySelector(".tt-contact-page-form__success, .form-control.error, .errors");
      if (hasFeedback) {
        initialTab = tab;
        return true;
      }
      return false;
    });
    activate(initialTab);
  }

  function init(root) {
    (root || document).querySelectorAll(".tt-contact-tabs").forEach(initTabs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
